module.exports = __webpack_public_path__ + "static/media/small-dropdown-white-select.28faae49.svg";